import { useState } from 'react';

import { Dialog, DialogContent, DialogHeader, DialogTrigger } from '@/components';

/** "View" trigger that opens the raw connector JSON in a dialog. */
export const RawJsonDialog = ({ rawJson }: { rawJson?: unknown }) => {
  const [open, setOpen] = useState(false);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button type="button" className="text-sm font-medium text-[#007AFF] hover:underline">
          View
        </button>
      </DialogTrigger>
      <DialogContent className="max-w-2xl">
        <DialogHeader className="block font-medium">
          <h2 className="text-lg font-bold">Full JSON Data</h2>
        </DialogHeader>
        <pre className="max-h-[60vh] overflow-auto rounded-md bg-slate-900 p-4 text-xs text-slate-100">
          {JSON.stringify(rawJson ?? {}, null, 2)}
        </pre>
      </DialogContent>
    </Dialog>
  );
};
